module.exports = __webpack_public_path__ + "static/interpolis.03487df7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/interpolis.jpg
// module id = 578
// module chunks = 35783957827783